module.exports = __webpack_public_path__ + "static/media/lovelyModal.f54d9d07.jpg";